export default __webpack_public_path__ + "static/media/navidad.d69357da.png";